import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng';

@Component({
  selector: 'customer-invoices',
  templateUrl: './customer-invoices.component.html',
})
export class CustomerInvoicesComponent implements OnInit {
  constructor(
    public messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {}
}
